import React, { useState, useEffect } from "react";
import { HiMinusSm, HiPlusSm } from "react-icons/hi";

const requestExtraDetails = [
  {
    icon: "/assets/icons/luggage.png",
    title: "Extra Luggage",
    text: "1 Carry-on and 1 Check in luggage per person in included in Service. If you have any extra luggage please choose number of bags you would like to add",
    action: "handleLuggage",
  },
  {
    icon: "/assets/icons/surfboard.png",
    title: "Surfboard",
    text: "If you are traveling with extra large item like ",
    action: "handleSurfboard",
  },
  {
    icon: "/assets/icons/baby-seat.png",
    title: "Baby Seats",
    text: "if your are traveling with Child (0 months to 4 Years old)",
    action: "handleBabySeats",
  },
  {
    icon: "/assets/icons/baby-booster.png",
    title: "Baby Booster",
    text: "If you are traveling with child (4 to 7 years old)",
    action: "handleBabyBooster",
  },
];

const RequestExtras = ({ onExtrasChange }) => {
  const [luggageQnt, setLuggageQnt] = useState(0);
  const [surfboardQnt, setSurfboardQnt] = useState(0);
  const [babySeatsQnt, setBabySeatsQnt] = useState(0);
  const [babyBoosterQnt, setBabyBoosterQnt] = useState(0);

  const [limits, setLimits] = useState({
    luggageMax: 5,
    surfboardMax: 2,
    babySeatsMax: 4,
    babyBoosterMax: 4,
  });

  const [prices, setPrices] = useState({
    luggagePrice: 0,
    surfboardPrice: 0,
    babySeatsPrice: 0,
    babyBoosterPrice: 0,
  });

  useEffect(() => {
    const fetchExtras = async () => {
      try {
        const res = await fetch("https://login.flymiles.com.au/api_sections/transafer/front_end/extras_prices.php");
        const data = await res.json();

        setLimits({
          luggageMax: +data.extra_luggage_max,
          surfboardMax: +data.surfboard_max,
          babySeatsMax: +data.baby_seats_max,
          babyBoosterMax: +data.baby_booster_max,
        });

        setPrices({
          luggagePrice: +data.extra_luggage_price,
          surfboardPrice: +data.surfboard_price,
          babySeatsPrice: +data.baby_seats_price,
          babyBoosterPrice: +data.baby_booster_price,
        });
      } catch (err) {
        console.error("Extras fetch failed", err);
      }
    };

    fetchExtras();
  }, []);

  const updateParent = () => {
    onExtrasChange({
      luggageQnt,
      surfboardQnt,
      babySeatsQnt,
      babyBoosterQnt,
      totalLuggagePrice: luggageQnt * prices.luggagePrice,
      totalSurfboardPrice: surfboardQnt * prices.surfboardPrice,
      totalBabySeatsPrice: babySeatsQnt * prices.babySeatsPrice,
      totalBabyBoosterPrice: babyBoosterQnt * prices.babyBoosterPrice,
    });
  };

  useEffect(() => {
    updateParent();
  }, [luggageQnt, surfboardQnt, babySeatsQnt, babyBoosterQnt, prices]);

  const handleChange = (type, action) => {
    const setFunc = {
      handleLuggage: setLuggageQnt,
      handleSurfboard: setSurfboardQnt,
      handleBabySeats: setBabySeatsQnt,
      handleBabyBooster: setBabyBoosterQnt,
    }[type];

    const currentVal = {
      handleLuggage: luggageQnt,
      handleSurfboard: surfboardQnt,
      handleBabySeats: babySeatsQnt,
      handleBabyBooster: babyBoosterQnt,
    }[type];

    const maxVal = {
      handleLuggage: limits.luggageMax,
      handleSurfboard: limits.surfboardMax,
      handleBabySeats: limits.babySeatsMax,
      handleBabyBooster: limits.babyBoosterMax,
    }[type];

    setFunc((prev) => {
      if (action === "increment" && prev < maxVal) return prev + 1;
      if (action === "decrement") return Math.max(prev - 1, 0);
      return prev;
    });
  };

  return (
    <div className="mt-6 border rounded-lg p-3">
      <h2 className="font-semibold text-xl">Request Extras</h2>
      <p className="mt-3 text-sm">
        You have 1 checked and 1 carry-on bag included in your transfer, would
        you like to request extra luggage or other items for your booking?
      </p>
      {requestExtraDetails.map((x, index) => {
        const val = {
          handleLuggage: luggageQnt,
          handleSurfboard: surfboardQnt,
          handleBabySeats: babySeatsQnt,
          handleBabyBooster: babyBoosterQnt,
        }[x.action];

        return (
          <div
            key={index}
            className="relative flex justify-between items-center mt-6 gap-6"
          >
            <div className="flex flex-col sm:flex-row sm:items-center gap-3">
              <img
                src={x.icon}
                alt=""
                className="flex-none w-16 object-contain"
              />
              <div className="flex flex-col gap-2">
                <h1 className="font-semibold">{x.title}</h1>
                <p className="text-sm">{x.text}</p>
              </div>
            </div>
            <div className="flex gap-2 items-center justify-between border rounded px-2">
              <input
                className="absolute right-0 top-0 sm:relative flex-none focus:outline-none w-9 h-9"
                type="number"
                value={val}
                readOnly
              />
              <div className="flex items-center gap-1">
                <button
                  onClick={() => handleChange(x.action, "decrement")}
                  className="bg-[#FFA100] h-6 w-6 flex items-center justify-center text-white text-2xl"
                >
                  <HiMinusSm />
                </button>
                <button
                  onClick={() => handleChange(x.action, "increment")}
                  className="bg-[#FFA100] h-6 w-6 flex items-center justify-center text-white text-2xl"
                >
                  <HiPlusSm />
                </button>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default RequestExtras;
